var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 23 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M19.6704 11.7162L0.529785 0.533203C0.529785 17.4245 0.529785 9.14576 0.529785 22.9325L19.6704 11.7162Z","fill":"white"}}),_vm._v(" "),_c('path',{attrs:{"d":"M22.9296 0.533691H19.3337V22.933H22.9296V0.533691Z","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }